export const getIsSafari = () => {
  return navigator.userAgent.search('Safari') >= 0 && navigator.userAgent.search('Chrome') < 0;
};
